import BaseModelAPI from '../BaseModelAPI';

export default class PicTypeList extends BaseModelAPI {

	static entity = 'pictypelist'
	static entityName = 'pictype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
